import React, { Component } from 'react';
import { Modal, Input, Form } from 'antd';

export default class Editmoudel extends Component {
    state = {
        isModalVisible: false,
        value: '',
    }

    setIsModalVisible = (bool) => {
        this.setState({ isModalVisible: bool })
    }

    showModal = () => {
        this.setIsModalVisible(true);
    };

    handleOkMoudel = () => {
        this.setIsModalVisible(false);
        const id = this.props.id
        const name = this.inputText.input.value
        this.props.editData(name, id)
    };

    handleOkAppSort = () => {
        this.setIsModalVisible(false);
        const id = this.props.id
        const name = this.inputText.input.value
        const code = this.appSort_mark.input.value
        const describe = this.describe.resizableTextArea.props.value
        this.props.editData(id, name, code, describe)
    }

    handleOkAppLabel = () => {
        this.setIsModalVisible(false);
        const id = this.props.id
        const name = this.inputText.input.value
        const describe = this.describe.resizableTextArea.props.value
        this.props.editData(id, name, describe)
    }

    handleCancel = () => {
        this.setIsModalVisible(false);
    };

    render() {
        const { isModalVisible } = this.state
        const { name, address, code, remark } = this.props
        const layout = {
            labelCol: {
                span: 3,
            },
            wrapperCol: {
                span: 21,
            },
        };
        return (
            <span>
                <a onClick={this.showModal} >
                    {name}
                </a>
                {   /* 使用三目运算符 嵌套的方法判断被点击的按钮 弹出不同对话框 */
                    address === '模块' ? (<Modal title="编辑模块" visible={isModalVisible} onOk={this.handleOkMoudel} onCancel={this.handleCancel}>
                        <Form
                            {...layout}
                            name="basic"
                        >
                            <Form.Item
                                label="名称"
                                name="username"
                                rules={[
                                    {
                                        required: true,
                                        message: '请输入模块名称',
                                    },
                                ]}
                            >
                                <Input defaultValue={name} ref={c => this.inputText = c} />
                            </Form.Item>
                        </Form>
                    </Modal>)
                        :
                        address === '应用分类' ? (
                            <Modal title="编辑应用分类" visible={isModalVisible} onOk={this.handleOkAppSort} onCancel={this.handleCancel}>
                                <Form
                                    {...layout}
                                    name="basic"
                                >
                                    <Form.Item
                                        label="名称"
                                        name="appSort_name"
                                        rules={[
                                            {
                                                required: true,
                                                message: '请输入应用分类名称',
                                            },
                                        ]}
                                    >
                                        <Input defaultValue={name} ref={c => this.inputText = c} />
                                    </Form.Item>
                                    <Form.Item
                                        label="标示"
                                        name="appSort_mark"
                                    >
                                        <Input defaultValue={code} ref={c => this.appSort_mark = c} />
                                    </Form.Item>
                                    <Form.Item
                                        label="描述"
                                    >
                                        <Input.TextArea placeholder='请输入描述' defaultValue={remark} ref={c => this.describe = c} />
                                    </Form.Item>
                                </Form>
                            </Modal>
                        )
                            :
                            address === '应用标签' ? (
                                <Modal title="编辑应用标签" visible={isModalVisible} onOk={this.handleOkAppLabel} onCancel={this.handleCancel}>
                                    <Form
                                        {...layout}
                                        name="basic"
                                    >
                                        <Form.Item
                                            label="名称"
                                            name="username"
                                            rules={[
                                                {
                                                    required: true,
                                                    message: '请输入应用标签名称',
                                                },
                                            ]}
                                        >
                                            <Input defaultValue={name} ref={c => this.inputText = c} />
                                        </Form.Item>
                                        <Form.Item
                                            label="描述"
                                        >
                                            <Input.TextArea placeholder="请输入描述" defaultValue={remark} ref={c => this.describe = c} />
                                        </Form.Item>
                                    </Form>
                                </Modal>
                            ) : ''
                }
            </span>
        )
    }
};